//#region DevExtreme Imports

import 'devextreme/ui/form'
import 'devextreme/ui/popup'
import 'devextreme/ui/toolbar'

//#endregion

import { IMRCashierPanelNewPaymentPopupController } from "./cashier-panel-new-payment-popup.controller"

//#region Asset Imports

import './cashier-panel-new-payment-popup.scss'
import * as TEMPLATE from './cashier-panel-new-payment-popup.tpl.html'

//#endregion


export const COMPONENT_NAME: string = 'imrCashierPanelNewPaymentPopup'

export class IMRCashierPanelNewPaymentPopupComponent implements ng.IComponentOptions {
    controller = ['userSession', IMRCashierPanelNewPaymentPopupController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}
